
import "jquery";
import "lib/bootstrap-treeview";

export class MlnTreeView extends HTMLElement {
    private _tree?: HTMLDivElement;
    private _data: any[] = [];
    private _levels: number = 2;
    private _onhoverColor: string = "#F5F5F5";
    private _selectedBackColor: string = "#428bca";
    private _collapseIcon: string = "fas fa-minus";
    private _expandIcon: string = "fas fa-plus";
    private _nodeIcon: string = "";
    private _emptyIcon: string = "";
    private _treeCreated = false;

    constructor() {
        super();
    }

    disconnectedCallback() {
        if (this._treeCreated)
            try {
                ($ as any)(this._tree).treeview("remove");
            } catch {

            }
    }

    connectedCallback() {
        this.recreateTree();
    }

    private recreateTree() {
        if (!this._tree) {
            this._tree = document.createElement("div");
            this.appendChild(this._tree);
        }
        if (this._treeCreated)
            try {
                ($ as any)(this._tree).treeview("remove");
            } catch { }

        ($ as any)(this._tree).treeview({
            data: this.treeData,
            levels: this.levels,
            onhoverColor: this.onhoverColor,
            selectedBackColor: this.selectedBackColor,
            collapseIcon: this.collapseIcon,
            expandIcon: this.expandIcon,
            nodeIcon: this.nodeIcon,
            emptyIcon: this.emptyIcon,
            onNodeSelected: (event: any, node: any) => {
                this.dispatchEvent(new CustomEvent("nodeSelected", { detail: { event, node } }));
            }
        })
        this._treeCreated = true;
    }

    get treeData() {
        return this._data;
    }

    set treeData(value) {
        this._data = value;
        this.recreateTree();
    }

    get levels() {
        return this._levels;
    }

    set levels(value) {
        this._levels = value;
        this.recreateTree();
    }

    get onhoverColor() {
        return this._onhoverColor;
    }

    set onhoverColor(value) {
        this._onhoverColor = value;
        this.recreateTree();
    }

    get selectedBackColor() {
        return this._selectedBackColor;
    }

    set selectedBackColor(value) {
        this._selectedBackColor = value;
        this.recreateTree();
    }

    get collapseIcon() {
        return this._collapseIcon;
    }

    set collapseIcon(value) {
        this._collapseIcon = value;
        this.recreateTree();
    }

    get expandIcon() {
        return this._expandIcon;
    }

    set expandIcon(value) {
        this._expandIcon = value;
        this.recreateTree();
    }

    get nodeIcon() {
        return this._nodeIcon;
    }

    set nodeIcon(value) {
        this._nodeIcon = value;
        this.recreateTree();
    }

    get emptyIcon() {
        return this._emptyIcon;
    }

    set emptyIcon(value) {
        this._emptyIcon = value;
        this.recreateTree();
    }
}

import { register } from "lib/wts.ui.register"

register("mln-treeview", MlnTreeView);

declare global {
    interface HTMLElementTagNameMap {
        "mln-treeview": MlnTreeView
    }
}